import React from 'react';
import { connect } from 'react-redux';
import {
    email, emailErrorCode, emailMessage,
    emailStatus,
    getIsFormValidating,
    getreactivationMessage,
    getreactivationParam,
    getreactivationStatus
} from "../../selectors";
import {
    MESSAGE_EMAIL_INVALID_FORMAT, PARAM_EMAIL,
} from "../../constants";
import {
    resendActivationLink,
    setEmail,
    setEmailValidationData,
    setReactivationData,
    setSuccessfulActivation,
} from "../../reducers";

const stateToProps = state => ({
    emailStatus: emailStatus(state),
    email: email(state),
    emailMessage: emailMessage(state),
    isFormValidating: getIsFormValidating(state),
    emailErrorCode: emailErrorCode(state),
    reactivationMessage: getreactivationMessage(state),
    reactivationStatus: getreactivationStatus(state),
    reactivationParam: getreactivationParam(state),
});

const actionsToProps = dispatch => ({
    setEmailValidationData: payload => dispatch(setEmailValidationData(payload)),
    setEmail: payload => dispatch(setEmail(payload)),
    setReactivationData: payload => dispatch(setReactivationData(payload)),
    setSuccessfulActivation: payload => dispatch(setSuccessfulActivation(payload)),
    resendActivationLink: payload => dispatch(resendActivationLink(payload)),
});

const Email = props => {

    const checkEmail = (event) => {
        const email = event.target.value.trim();

        if (email.length > 0) {
            let regex = new RegExp('^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$');
            const isEmailWellFormed = regex.test(email);

            if (!isEmailWellFormed) {
                props.setEmailValidationData({
                    emailStatus: 'error',
                    emailMessage: MESSAGE_EMAIL_INVALID_FORMAT
                })
            } else {
                props.setEmailValidationData({
                    emailStatus: 'success',
                    emailMessage: ''
                })
            }
        } else {
            props.setEmailValidationData({
                emailStatus: '',
                emailMessage: ''
            })
        }
    };

    const reactivationReset = (paramName) => {
        if (paramName === props.reactivationParam) {
            props.setReactivationData({
                message: '',
                paramName: '',
                status: '',
                code: '',
            });
        }
    };

    const errorMessageEmail = () => {
        let returnMessage = (
            <p className="callout p10 txt-l error"
               dangerouslySetInnerHTML={(() => ({ __html: `${props.emailMessage} ` }))()}
            />
        );

        if (props.emailErrorCode === -19735) {
            const text = props.emailMessage.split('here');
            returnMessage = (
                <p className="callout p10 txt-l error">
                    {text[0]}
                    <span className="callout--link-clr" onClick={() => requestActivationEmail()}>here</span>
                    {text[1]}
                </p>
            );
        }

        if (props.reactivationCode < 0) {
            return (
                <React.Fragment>
                    <p className="callout p10 txt-l error"
                       dangerouslySetInnerHTML={(() => ({ __html: `${props.reactivationMessage} ` }))()}
                    />
                    {returnMessage}
                </React.Fragment>
            );
        }
        return returnMessage;
    };

    const requestActivationEmail = () => {
        props.setSuccessfulActivation({ paramName: PARAM_EMAIL });
        props.resendActivationLink({
            paramName: PARAM_EMAIL,
            paramValue: props.email,
        });
    };

    const showSuccessEmail = props.reactivationStatus === 'success' && props.reactivationParam === PARAM_EMAIL && props.emailStatus === 'success';

    const successMessage = () => {
        const returnMessage = props.reactivationMessage.replace('@email', props.mailFrom);
        return (
            <p className="callout callout--success p10 txt-l"
               dangerouslySetInnerHTML={(() => ({ __html: `${returnMessage} ` }))()}
            />
        );
    };

    return (
        <div className={`form-row ${props.emailStatus}`}>
            <label className="form-label">Email</label>

            <input type="text" id="email" className="form-input" placeholder="address@domain.com"
                   onBlur={checkEmail} value={props.email} disabled={props.isFormValidating}
                   onChange={(e) => {
                       const email = e.target.value.replace(/\s+/g, '');
                       if (props.emailStatus === 'success') {
                           props.setEmailValidationData({ emailStatus: '' });
                       }

                       props.setEmail(email);
                       reactivationReset(PARAM_EMAIL);
                   }}
            />

            {props.emailStatus !== 'error' ? null : errorMessageEmail()}

            {showSuccessEmail ? successMessage() : null}

            <i className="form-status" />
        </div>
    );
}

export default connect(
    stateToProps,
    actionsToProps
)(Email);
